import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import moment from 'moment';
import { AccountRestrictedSoonPopup } from './account-restricted-soon-popup';
import { useToggle } from '../../../infra/small-tools/use-toggle';
import { useStripeHostedOnboardingInfo } from '../hooks/use-stripe-hosted-onboarding-info';
import { sessionKVStore } from '../../../infra/persistence';
import { useFeatureFlags } from '../../../infra/feature-flags';
import { getUrlPrefixFromView } from '../../../infra/routing';
import { useSession } from '../../../infra/session';
var ACCOUNT_RESTRICTED_SOON_LAST_SHOWN = 'squire_accountRestrictedSoonLastShown';
export var AccountRestrictedSoonContainer = function () {
    var modal = useToggle(false);
    var session = useSession().data;
    var accountRestrictedSoonAnnouncement = useFeatureFlags().accountRestrictedSoonAnnouncement;
    var stripeHostedOnboardingInfo = useStripeHostedOnboardingInfo(accountRestrictedSoonAnnouncement);
    var urlPrefix = getUrlPrefixFromView(session.view);
    var updateButtonUrl = "".concat(urlPrefix, "/settings/payment-processing");
    useEffect(function () {
        var _a;
        // we purposely use sessionKVStore, to show the popup every session
        var lastShownAtRaw = sessionKVStore.getItem(ACCOUNT_RESTRICTED_SOON_LAST_SHOWN);
        var shownMoreThanADayAgo = lastShownAtRaw
            ? moment.duration(moment().diff(moment(lastShownAtRaw))).asHours() > 24
            : true;
        if (shownMoreThanADayAgo && ((_a = stripeHostedOnboardingInfo === null || stripeHostedOnboardingInfo === void 0 ? void 0 : stripeHostedOnboardingInfo.info) === null || _a === void 0 ? void 0 : _a.status)) {
            var stripeAccountStatus = stripeHostedOnboardingInfo.info.status;
            if (['Restricted Soon', 'Restricted'].includes(stripeAccountStatus)) {
                sessionKVStore.setItem(ACCOUNT_RESTRICTED_SOON_LAST_SHOWN, new Date().toISOString());
                modal.setOn();
            }
        }
    }, [stripeHostedOnboardingInfo === null || stripeHostedOnboardingInfo === void 0 ? void 0 : stripeHostedOnboardingInfo.info]);
    if (!modal.isOn) {
        return null;
    }
    return _jsx(AccountRestrictedSoonPopup, { onCloseHandler: modal.setOff, updateButtonUrl: updateButtonUrl });
};
